import { action } from 'typesafe-actions';
import { DataActionTypes } from './types';
import { IAgentFromAPI, ICourse } from '../../types';
import { IModal } from '../ui/types';
import { FinancialState } from '../student/finanacials/types';

export const getAgents = (searchQuery?: string) => action(DataActionTypes.GET_AGENTS, searchQuery);
export const getAgentsSuccess = (agents: IAgentFromAPI[]) => action(DataActionTypes.GET_AGENTS_SUCCESS, agents);
export const getAgentsFailure = (error: string) => action(DataActionTypes.GET_AGENTS_FAILURE, error);

export const getCourseSuggestions = (searchQuery: string) =>
  action(DataActionTypes.GET_COURSE_SUGGESTIONS, {
    searchQuery
  });

export const getCourseSuggesstionsSuccess = (courses: ICourse[]) =>
  action(DataActionTypes.GET_COURSE_SUGGESTIONS_SUCCESS, {
    courses
  });

export const getCourseSuggesstionsFailure = (error: string) =>
  action(DataActionTypes.GET_COURSE_SUGGESTIONS_FAILURE, {
    error
  });

export const retryAPICall = (callName: string, retryNumber: number, timeToNextCall: number) =>
  action(DataActionTypes.RETRY_API_CALL, {
    callName,
    retryNumber,
    timeToNextCall
  });
export const retryAPICallSuccess = (callName: string) => action(DataActionTypes.RETRY_API_CALL_SUCCESS, callName);
export const retryAPICallFailure = (callName: string, error: string) =>
  action(DataActionTypes.RETRY_API_CALL_FAILED, { callName, error });

export const getUploadUrl = (openModal: IModal, fileName: string, fileType: string, fileIndex: number, file: File) =>
  action(DataActionTypes.GET_UPLOAD_FILE_URL, {
    openModal,
    fileName,
    fileType,
    fileIndex,
    file
  });

export const getUploadUrlFailure = (error: string) =>
  action(DataActionTypes.GET_UPLOAD_FILE_URL_FAILURE, {
    error
  });

export const uploadFile = (file: File, url: string) =>
  action(DataActionTypes.UPLOAD_FILE, {
    file,
    url
  });

export const uploadFileSuccess = (
  sponsorType: string | null,
  sponsorKey: string | null,
  docType: string | null,
  docKey: string | null,
  fileNames: string[],
  isFinanceDocumentModal: boolean,
  isFollowUpModal: boolean,
  finance: FinancialState
) => {
  return action(DataActionTypes.UPLOAD_FILE_SUCCESS, {
    sponsorType,
    sponsorKey,
    docType,
    docKey,
    fileNames,
    isFinanceDocumentModal,
    isFollowUpModal,
    finance
  });
};

export const uploadFileFailure = (error: string) =>
  action(DataActionTypes.UPLOAD_FILE_FAILURE, {
    error
  });
